import { combineReducers } from 'redux'
import { loadingBarReducer } from 'react-redux-loading-bar'
import type { Action, AppState } from './types'

import auth from './auth'
import * as authActions from './auth/actions'
import api from './api'
import customFollowUpLabels from './customFollowUpLabels'
import dashboard from './dashboard'
import dataExtractRequest from './dataExtractRequest'
import enrolments from './enrolments'
import enrolmentEntitlements from './enrolmentEntitlements'
import enrolmentDraft from './enrolmentDraft'
import salesforcePortalTabs from './salesforcePortalTabs'
import globalNotification from './globalNotification'
import memberships from './memberships'
import reportAnalyticsDetails from './reportAnalyticsDetails'
import organisations from './organisations'
import grantedOrganisations from './grantedOrganisations'
import participants from './participants'
import passwordReset from './passwordReset'
import programEvents from './programEvents'
import report from './report'
import reports from './reports'
import reportsOverview from './reportsOverview'
import request from './request'
import roundEnrolment from './roundEnrolment'
import roundEnrolments from './roundEnrolments'
import roundEnrolmentsOverview from './roundEnrolmentsOverview'
import uploads from './uploads'
import notificationPreference from './notificationPreference'
import calendarPreference from './calendarPreference'
import generalPreference from './generalPreference'
import accountPreference from './accountPreference'
import unsavedChanges from './unsavedChanges'

const appReducer: (state: any | null | undefined, action: Action) => AppState = combineReducers({
  auth,
  api,
  customFollowUpLabels,
  dashboard,
  dataExtractRequest,
  enrolments,
  enrolmentEntitlements,
  enrolmentDraft,
  salesforcePortalTabs,
  globalNotification,
  memberships,
  organisations,
  grantedOrganisations,
  participants,
  passwordReset,
  programEvents,
  report,
  reports,
  reportsOverview,
  request,
  roundEnrolment,
  roundEnrolments,
  roundEnrolmentsOverview,
  reportAnalyticsDetails,
  loadingBar: loadingBarReducer,
  uploads,
  notificationPreference,
  calendarPreference,
  generalPreference,
  accountPreference,
  unsavedChanges,
})

const rootReducer = (state: any | null | undefined, action: Action): AppState => {
  if (action.type === authActions.CLEAN_STORE_STATE) {
    state = undefined
  }

  return appReducer(state, action)
}

export default rootReducer
